import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.18 14.3c-1.03.72-2.49.83-3.07.84-1.59.03-3.12-.59-4.27-1.72-.65-.64-1.13-1.4-1.44-2.22h5.44c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H4.11C4.04 9.81 4 9.42 4 9.02c0-.15.01-.31.02-.46h5.82c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H4.18c.26-1.06.81-2.04 1.61-2.84a6.093 6.093 0 0 1 4.35-1.79c.91.02 2.18.22 3.04.85.22.16.54.12.7-.11.16-.22.12-.54-.11-.7-.89-.66-2.26-1.02-3.63-1.04-1.91 0-3.7.74-5.05 2.08-1 .99-1.66 2.21-1.94 3.55H1.53c-.28 0-.5.22-.5.5s.22.5.5.5h1.49c-.01.15-.02.3-.02.46 0 .4.04.79.1 1.18H1.53c-.28 0-.5.22-.5.5s.22.5.5.5h1.81c.35 1.1.96 2.1 1.8 2.93a6.917 6.917 0 0 0 4.89 2.01h.11c.84-.02 2.42-.17 3.63-1.02.23-.16.28-.47.12-.7a.512.512 0 0 0-.71-.12z"
    }, null, -1)
  ])))
}
export default { render };